import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StreamRecord } from "@/savaradio/common";
export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>



const initialState: { value?: StreamRecord[], isLoading: IsLoading } = { isLoading: initialLoading }

const streamRecordSlice = createSlice({
  initialState,
  name: "stream_record_slice",
  reducers: {
    reset: (state, action: PayloadAction<StreamRecord[] | undefined>) => {
      state.value = action.payload
    },
    append: (state, action: PayloadAction<StreamRecord>) => {
      if (!state.value) state.value = [action.payload]
      if (
        state.value &&
        !state.value.some(item => item._id === action.payload._id)
      ) state.value = state.value.concat(action.payload)
    },
    pop: (state, action: PayloadAction<StreamRecord>) => {
      if (!!state.value) state.value = state.value.filter(stream_record => stream_record._id !== action.payload._id)
    },
    merge: (state, action: PayloadAction<StreamRecord>) => {
      if (!!state.value) state.value = state.value.map(stream_record => (
        stream_record._id === action.payload._id ?
          action.payload : stream_record
      ))
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, reset, merge, pop, setLoading } = streamRecordSlice.actions
export const stream_record_slice = streamRecordSlice.reducer